import * as React from 'react';
import { Route, Link, withRouter } from 'react-router-dom';
// import { ENGINE_METHOD_DIGESTS } from 'constants';
import { connect } from 'react-redux';

class Header extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            // header is closed initially for dashboard and Login
            // headerMenuDisplay: true,
            activeMenu: 'content',
            toggleHamburgerClass: '',
            toggleHeaderRightClass: '',
            route: ''
        };
        this.onHamBurgerClick = this.onHamBurgerClick.bind(this);
    }

    public componentWillMount() {
        const route = location.hash;
        const getCurrentRoute = route.toString().split("/");
        this.setState({
            route: getCurrentRoute[1]
        })
    }

    public componentDidMount() {
        const path = location.hash;
        const removeSpecialChars = path.replace(/[^a-zA-Z ]/g, "");

        if (removeSpecialChars === "login" || removeSpecialChars === "dashboard") {
            this.setState({
                headerMenuDisplay: false
            })
        }
    }
    public componentWillReceiveProps(props: any) {
        if (props.logout) {
            this.props.history.push("/login")
        }
    }
    public onHamBurgerClick(elm: any) {
        const hamburgerClass = this.state.toggleHamburgerClass === '' ? "hamburger-close" : '';
        const headerRightClass = this.state.toggleHeaderRightClass === '' ? "header-right-show" : '';
        this.setState({
            toggleHamburgerClass: hamburgerClass,
            toggleHeaderRightClass: headerRightClass
        })
    }

    public render() {
        const classHamNames = "hamburger-menu " + this.state.toggleHamburgerClass;
        const classHeaderNames = "header-right " + this.state.toggleHeaderRightClass
        return (
            <div>
                <div className="header">
                    <div className="logo">
                        <a href="/"><img src="/assets/images/logo.png" /></a>
                    </div>
                    <div className={classHamNames} onClick={(e) => this.onHamBurgerClick(e)}>
                        <span></span>
                    </div>
                    <div className={classHeaderNames} >
                        <div className="user-box">

                        </div>
                        <div className="main-menu">
                            <ul>
                                <li className={this.state.route === 'subscriptionReports' ? "active" : ""}>
                                    <Link to={`/subscriptionReports/allUsers`} >Subscription</Link>
                                </li>
                                <li className={this.state.route === 'productionreports' ? "active" : ""}>
                                    <Link to={`/productionreports/All`}>Production</Link>
                                </li>
                                <li className={this.state.route === 'productionSpeed' ? "active" : ""}>
                                    <Link to={`/productionSpeed/All`} >Production Speed</Link>
                                </li>
                                <li className={this.state.route === 'enclosurePO' ? "active" : ""}>
                                    <Link to={`/enclosurePO/All`} >Enclosure PO</Link>
                                </li>
                                <li className={this.state.route === 'all41Projects' ? "active" : ""}>
                                    <Link to={`/all41Projects/All`} >All 4.1 Projects</Link>
                                </li>
                                <li className={this.state.route === 'openModsReport' ? "active" : ""}>
                                    <Link to={`/openModsReport/All`} >Open Mods</Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <Route exact={true} path="/" />
            </div>
        );
    }
}

const mapStateToProps = (state: any) => ({
    logout: state.loginUser.logout
});

export default withRouter<any>(connect(mapStateToProps)(Header));



// WEBPACK FOOTER //
// ./src/sharedcomponents/header.tsx